export default __webpack_public_path__ + "static/media/logo-facebook.628f2a8a.svg";